import React from 'react';
import ChannelForm from './ChannelForm';

const ChannelCreatePage = () => {
  return (
    <ChannelForm />
  );
};

export default ChannelCreatePage;